import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-717bae8a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tiles-container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "text-overline mb-1",
  style: {"visibility":"hidden"}
}, "filler", -1))
const _hoisted_3 = { class: "text-h6 mb-1" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-caption" }, " Over the last 28 days ", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "text-overline mb-1",
  style: {"visibility":"hidden"}
}, "filler", -1))
const _hoisted_6 = { class: "text-h6 mb-1" }
const _hoisted_7 = { style: {"width":"300px","height":"300px"} }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "text-overline mb-1",
  style: {"visibility":"hidden"}
}, "filler", -1))
const _hoisted_9 = { class: "text-h6 mb-1" }
const _hoisted_10 = { style: {"width":"300px","height":"300px"} }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_13 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_card_item = _resolveComponent("v-card-item")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_Pie = _resolveComponent("Pie")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_main = _resolveComponent("v-main")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_v_card, {
        elevation: "4",
        color: "white",
        variant: "elevated",
        class: "mx-auto my-3",
        style: {"width":"300px","height":"175px"}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card_item, null, {
            default: _withCtx(() => [
              _createElementVNode("div", null, [
                _hoisted_2,
                _createElementVNode("div", _hoisted_3, "Number of " + _toDisplayString(_ctx.breakdownDisplayNamePlural), 1),
                _hoisted_4,
                _createElementVNode("p", null, _toDisplayString(_ctx.numberOfBreakdowns), 1)
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _createVNode(_component_v_main, {
      class: "p-1",
      style: {"min-height":"300px"}
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_container, {
          style: {"min-height":"300px"},
          class: "px-4 elevation-2"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, { cols: "6" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_card, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_card_item, { class: "d-flex justify-center align-center" }, {
                          default: _withCtx(() => [
                            _hoisted_5,
                            _createElementVNode("div", _hoisted_6, "Top 5 " + _toDisplayString(_ctx.breakdownDisplayNamePlural) + " by accepted prompts", 1),
                            _createElementVNode("div", _hoisted_7, [
                              _createVNode(_component_Pie, {
                                data: _ctx.breakdownsChartDataTop5AcceptedPrompts,
                                options: _ctx.chartOptions
                              }, null, 8, ["data", "options"])
                            ])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, { cols: "6" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_card, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_card_item, { class: "d-flex justify-center align-center" }, {
                          default: _withCtx(() => [
                            _hoisted_8,
                            _createElementVNode("div", _hoisted_9, "Top 5 " + _toDisplayString(_ctx.breakdownDisplayNamePlural) + " by acceptance rate", 1),
                            _createElementVNode("div", _hoisted_10, [
                              _createVNode(_component_Pie, {
                                data: _ctx.breakdownsChartDataTop5AcceptanceRate,
                                options: _ctx.chartOptions
                              }, null, 8, ["data", "options"])
                            ])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _hoisted_11,
            _createElementVNode("h2", null, _toDisplayString(_ctx.breakdownDisplayNamePlural) + " Breakdown ", 1),
            _hoisted_12,
            _createVNode(_component_v_data_table, {
              headers: _ctx.headers,
              items: Array.from(_ctx.breakdowns),
              class: "elevation-2",
              style: {"padding-left":"100px","padding-right":"100px"}
            }, {
              item: _withCtx(({item}) => [
                _createElementVNode("tr", null, [
                  _createElementVNode("td", null, _toDisplayString(item[0]), 1),
                  _createElementVNode("td", null, _toDisplayString(item[1].acceptedPrompts), 1),
                  _createElementVNode("td", null, _toDisplayString(item[1].acceptedLinesOfCode), 1),
                  (item[1].acceptanceRate !== undefined)
                    ? (_openBlock(), _createElementBlock("td", _hoisted_13, _toDisplayString(item[1].acceptanceRate.toFixed(2)) + "%", 1))
                    : _createCommentVNode("", true)
                ])
              ]),
              _: 1
            }, 8, ["headers", "items"])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}